import React from "react";

type attributes = {
    department: string,
    headCount: number,
    processes:[]
}

export const StatPanel = (props: { title: string, statNumber: string }) => {
    return (<div className="text-center">
        <h5>{props.statNumber}</h5>
        {props.title}
    </div>);
}
export const TeamCard = (props: attributes) => {

    const deriveAllocationColor = (statNum:number)=>{
        if(statNum === 100) return "success";
        if(statNum ===0) return  "danger";
        if(statNum >0 && statNum <100) return "primary";
    }

    return (
        <>
            <div className={"card d-inline-flex w-auto m-2 p-3 shadow border-2 rounded border-light"}>
                <div>
                    <h5 className="card-title">{props.department}</h5>
                </div>
                <div className={"d-flex justify-content-between flex-row gap-4"}>
                    <StatPanel title={"Head Count"} statNumber={props.headCount + ''}/>
                    {props.processes.map((p:any)=>{
                        if(p.ProcessCount>0){
                        return(
                            <StatPanel title={p.ProcessName} statNumber={p.ProcessCount}/>
                        )
                        }
                    })}
                    {/* <StatPanel title={"Buffer"} statNumber={props.buffer + '%'}/>
                    <StatPanel title={"Allocation"} statNumber={props.alloction + '%'}/> */}
                </div>
            </div>
        </>
    )
}
